const CONTRACT_UI_PREFIX = "KLARGO_CONTRACT_UI:";

const UI_FIELDS = ["equipment", "knownDefects", "odometer", "keysCount", "debt", "loan"];

export function createContractUiMessage(field, value) {
  return `${CONTRACT_UI_PREFIX}${JSON.stringify({ field, value })}`;
}

function parseContractUiMessage(entry) {
  if (entry?.user !== "seller" || typeof entry.message !== "string" || !entry.message.startsWith(CONTRACT_UI_PREFIX)) return null;
  try {
    const payload = JSON.parse(entry.message.slice(CONTRACT_UI_PREFIX.length));
    return UI_FIELDS.includes(payload?.field) ? payload : null;
  } catch (_) {
    // Ignore malformed or unrelated realtime messages.
    return null;
  }
}

export function readContractUiUpdates(messages = []) {
  return messages.reduce((updates, entry) => {
    const payload = parseContractUiMessage(entry);
    if (payload) updates[payload.field] = payload.value;
    return updates;
  }, {});
}

// Every change the seller has announced, oldest first (readContractUiUpdates keeps only the last
// value per field). The buyer's page tells the buyer about each one as it arrives.
export function listContractUiChanges(messages = []) {
  return messages.map(parseContractUiMessage).filter(Boolean);
}

// The seller's "Change" on the odometer / number of keys is announced the way the price dialog is:
// the buyer's page is locked while the seller edits, and released by the saved value (the usual
// contract-ui message above) or by a cancel.
export const FIELD_LOCK_MSG = {
  odometer: { changing: "Seller is changing odometer", cancelled: "Seller cancelled odometer change" },
  keysCount: { changing: "Seller is changing keys", cancelled: "Seller cancelled keys change" },
};

// The field the seller is editing right now ("odometer" | "keysCount"), or null. The latest message
// about a field decides: "changing" locks, a cancel or the saved value releases.
export function readLockedField(messages = []) {
  const state = {};
  let lockedOrder = [];
  messages.forEach((entry) => {
    if (entry?.user !== "seller") return;
    Object.entries(FIELD_LOCK_MSG).forEach(([field, msgs]) => {
      if (entry.message === msgs.changing) {
        state[field] = true;
        lockedOrder = lockedOrder.filter((f) => f !== field).concat(field);
      } else if (entry.message === msgs.cancelled) {
        state[field] = false;
      }
    });
    const payload = parseContractUiMessage(entry);
    if (payload && state[payload.field]) state[payload.field] = false;
  });
  const active = lockedOrder.filter((f) => state[f]);
  return active.length ? active[active.length - 1] : null;
}
